var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "page-box flex" }, [
    _c("section", { staticClass: "left-panel" }, [
      _c(
        "div",
        { staticClass: "search-section" },
        [
          _c("lz-icon", {
            attrs: {
              type: "iconfont",
              name: "lzicon-search_outline icon",
              size: 15
            },
            nativeOn: {
              click: function($event) {
                return _vm.handleSearchClick.apply(null, arguments)
              }
            }
          }),
          _c("el-input", {
            staticClass: "search-input",
            attrs: { clearable: "", placeholder: _vm.$t("搜索系统名称") },
            on: { clear: _vm.handleSearchClear },
            nativeOn: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleSearchClick.apply(null, arguments)
              }
            },
            model: {
              value: _vm.searchKeyword,
              callback: function($$v) {
                _vm.searchKeyword = $$v
              },
              expression: "searchKeyword"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "content-section mt-10" }, [
        _c(
          "div",
          { staticClass: "head-view flex" },
          [
            _c("lz-icon", {
              attrs: {
                type: "iconfont",
                name: "lzicon-spherical",
                size: 16,
                color: "#497CF6"
              }
            }),
            _c("p", [_vm._v(_vm._s(_vm.$t("选择系统")))])
          ],
          1
        ),
        _c(
          "ul",
          { staticClass: "list-view" },
          [
            _vm._l(_vm.projectList, function(i) {
              return [
                _c(
                  "li",
                  {
                    key: i.projectCode,
                    class: {
                      selected: i.projectCode === _vm.activeProjectCode
                    },
                    on: {
                      click: function($event) {
                        return _vm.handleItemClick(i)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(i.projectCode) + " ")]
                )
              ]
            })
          ],
          2
        )
      ])
    ]),
    _c("section", { staticClass: "right-panel" }, [
      _c("div", { staticClass: "title-section" }, [
        _c("img", {
          attrs: { src: require("@/assets/images/authority-icon.png"), alt: "" }
        }),
        _c("span", [_vm._v(_vm._s(_vm.$t("设置该角色权限")))])
      ]),
      _c(
        "div",
        { staticClass: "content-section" },
        [
          _c("RoleTree", {
            ref: "boxRefView",
            attrs: { title: _vm.activeProjectCode },
            on: { emitCheck: _vm.renderCheck }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }